<template>
  <div>
    <span v-if="row.estado == 'A'">
      <span v-if="mostrarModalValidaDocumento()">
        <b-button variant="danger" style="float:right" v-on:click="modalValidaDocumento(row,'R')">Rechazar</b-button>
      </span>
    </span>
    <span v-else-if="row.estado == 'P'">
      <span v-if="mostrarEliminarDocumento()">
        <b-button variant="danger" style="float:right; margin-left: 5px;" v-on:click="eliminarDocumento(row)">Eliminar</b-button>
      </span>
      <span v-if="mostrarModalValidaDocumento()">
        <b-button variant="primary" style="float:right; margin-left: 5px;" v-on:click="modalValidaDocumento(row,'A')">Aprobar</b-button>
      </span>
      <span v-if="mostrarModalValidaDocumento()">
        <b-button variant="danger" style="float:right" v-on:click="modalValidaDocumento(row,'R')">Rechazar</b-button>
      </span>
    </span>
  </div>
</template>

<script>

import {userService, globales} from "@/services";

export default {
  name: "AccionesVerDocumento",
  props: {
    row : {default : null},
  },
  methods : {
    modalValidaDocumento(row, estado){
      this.$emit('modal-valida-documento', row, estado);
    }, 
    eliminarDocumento(row){
      this.$emit('eliminar-documento', row);
    },
    mostrarModalValidaDocumento(){
      if(globales.isInArray(
        userService.getUser().perfiles, 
        [globales.perfil.admin, globales.perfil.admin_cliente, globales.perfil.control_contratista, globales.perfil.administrador_sucursal] )){
          if(userService.getUser().permiso == "1"){
            return true;
          }
      }
      
      return false;
    },
    mostrarEliminarDocumento(){
      if(userService.getUser().permiso == "1"){
        return true;
      }
      return false;
    },
  } 
}
</script>

<style scoped>
</style>